<template>
  <b-col
    v-if="!(get_config('integration.welfare') && (is_vivamod() || is_hotels()))"
    :md="get_config('integration.welfare') || is_vivamod() || is_hotels() ? 3 : 6"
  ><!-- TAZ-533: cambio copy temporanei VH -->
    <b-row>
      <b-col md="6" v-if="!is_vivamod() && !is_hotels()">
        <div class="h6 site-footer__title">
          Viaggia con {{ get_config().site.brand }}
          {{ get_config().site.payoff }}
        </div>
        <ul class="site-footer__links">
          <li class="site-footer__link">
            <router-link :to="{ name: 'about', hash: '#vadobay' }">
              Cos'è {{ get_config().site.brand }}
            </router-link>
          </li>
          <li class="site-footer__link">
            <router-link :to="{ name: 'about', hash: '#prenota-un-viaggio' }">
              Prenota un viaggio
            </router-link>
          </li>
          <li class="site-footer__link">
            <router-link :to="{ name: 'about', hash: '#contattaci' }">
              Contattaci
            </router-link>
          </li>
        </ul>
      </b-col>
      <b-col md="6" v-if="!get_config('integration.welfare')">
        <div class="h6 site-footer__title">Chi siamo</div>
        <ul class="site-footer__links">
          <li class="site-footer__link">
            <router-link :to="{ name: 'about' }">
              {{ get_config().site.brand }} di Salabam Solutions
            </router-link>
          </li>
          <li class="site-footer__link">
            <a href="https://www.salabamsolutions.com" target="_blank">
              Salabam Solutions
            </a>
          </li>
          <li v-if="is_vivamod()" class="site-footer__link">
            <a href="https://salabamsolutions.com/contatti/" target="_blank">
              Contatti
            </a>
          </li>
        </ul>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
export default {
  name: "site-footer",
  components: {},
  created() {},
  computed: {},
  watch: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {},
}
</script>

<style lang="scss"></style>
